/**
 * share hight charts module
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { HighchartsChartModule } from 'highcharts-angular';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';

import { EaCircleChartComponent } from './ea-circle-chart/ea-circle-chart.component';
import { EaColumnComponent } from './ea-column/ea-column.component';
import { EaGaugeComponent } from './ea-gauge/ea-gauge.component';
import { EaLineComponent } from './ea-line/ea-line.component';
import { EaMapChartComponent } from './ea-map-chart/ea-map-chart.component';
import { EaMixComponent } from './ea-mix/ea-mix.component';
import { EaPieComponent } from './ea-pie/ea-pie.component';

import * as highcharts from 'highcharts';
import { EaChartAbstractComponent } from './ea-chart-abstract/ea-chart-abstract.component';
import { EaChartsLegendComponent } from './ea-charts-legend/ea-charts-legend.component';
import { EaVennChartComponent } from './ea-venn-chart/ea-venn-chart.component';

const HighchartsMore = require('highcharts/highcharts-more');
const Venn = require('highcharts/modules/venn');
HighchartsMore(highcharts);
Venn(highcharts);
highcharts.setOptions({
  lang: {
    months: [
      'janvier',
      'février',
      'mars',
      'avril',
      'mai',
      'juin',
      'juillet',
      'août',
      'septembre',
      'octobre',
      'novembre',
      'décembre',
    ],
    weekdays: [
      'Dimanche',
      'Lundi',
      'Mardi',
      'Mercredi',
      'Jeudi',
      'Vendredi',
      'Samedi',
    ],
    shortMonths: [
      'Jan',
      'Fev',
      'Mar',
      'Avr',
      'Mai',
      'Juin',
      'Juil',
      'Aout',
      'Sept',
      'Oct',
      'Nov',
      'Déc',
    ],
    decimalPoint: ',',
    resetZoom: 'Réinitialiser le zoom',
    resetZoomTitle: 'Réinitialiser le zoom au niveau 1:1',
    thousandsSep: ' ',
  },
});

@NgModule({
  imports: [
    CommonModule,
    HighchartsChartModule,
    Ng2GoogleChartsModule,
    TranslateModule,
  ],
  declarations: [
    EaPieComponent,
    EaLineComponent,
    EaGaugeComponent,
    EaColumnComponent,
    EaMixComponent,
    EaCircleChartComponent,
    EaMapChartComponent,
    EaChartsLegendComponent,
    EaChartAbstractComponent,
    EaVennChartComponent,
  ],
  exports: [
    HighchartsChartModule,
    EaPieComponent,
    EaLineComponent,
    EaGaugeComponent,
    EaColumnComponent,
    EaMixComponent,
    EaCircleChartComponent,
    EaMapChartComponent,
    EaChartsLegendComponent,
    EaVennChartComponent,
  ],
})
export class EaChartsModule {}
